import styled from 'styled-components';

const CommonGroupStyled = styled.div`
  padding: 24px;
  .comm_top {
    display: flex;
    justify-content: space-between;
    .comm_top_left_tp {
      color: #212121;
      font-size: 16px;
    }
    .comm_top_left_btm {
      color: #939393;
      font-size: 12px;
    }
    .comm_top_right {
      width: 107px;
      height: 32px;
      color: #424242;
    }
    .MuiSelect-icon {
      color: #cccccc;
    }
    .MuiOutlinedInput-input {
      margin-left: 10px;
    }
    .MuiOutlinedInput-notchedOutline legend span {
      display: none;
    }
  }
`;

export default CommonGroupStyled;
